import React, { ReactNode } from 'react'
import { ColorsSchemeNames } from '@rst/ui-ts'

import { Animations } from '../../../../types'
import { BlockAnimationCore } from './block-animation-core'
import { useBlockAppearance } from './use-block-appearance'

type BlockAnimationProps = {
	animation?: Animations.AnimationParams
	bgColor?: ColorsSchemeNames | string
	bgImage?: string
	blockId?: string
	blockType?: string
	children?: ReactNode
	className?: string
}

const BlockAnimation = ({
	animation,
	bgColor,
	bgImage,
	blockId,
	children,
	className,
}: BlockAnimationProps) => {
	const appearance = useBlockAppearance({ blockId })

	return (
		<BlockAnimationCore
			animation={animation}
			bgColor={bgColor}
			bgImage={bgImage}
			className={className}
			{...appearance}
		>
			{children}
		</BlockAnimationCore>
	)
}

export { BlockAnimation }
export { useAnimationBack } from './use-animation-back'
